export const getArea = () => {
    var _a;
    // this value cloud be area name like 'yokohama', but at some cases not.
    const subDirName = window.location.pathname.split("/")[1];
    const AREA_DIC = [
        { dirName: "yokohama", area: "横浜" },
        { dirName: "omiya", area: "大宮" },
        { dirName: "osaka", area: "大阪" },
    ];
    const area = ((_a = AREA_DIC.find((a) => a.dirName === subDirName)) === null || _a === void 0 ? void 0 : _a.area) || "東京,横浜,大宮";
    return area;
};
